<!-- .topbar -->
<div class="site-header__topbar topbar">
    <div class="topbar__container container">
        <div class="topbar__row">
            <!-- <div class="topbar__item topbar__item--link c">
                <a class="topbar-link" routerLink="/"> *Delivery all over the World</a>
            </div>
            <div class="topbar__spring"></div> -->
            <div class="col-3">
                <div class="topbar__item topbar__item--link">
                    <a class="topbar-link" style="color: black;" href="tel:{{phone[0]}}"><b><i   class="fa fa-phone" aria-hidden="true"></i></b>&nbsp; {{phone[0]}}</a>
                </div>
            </div>
            <div class="col-7 text-center">
                    <a class="" style="color: black;" ><b> Flat <span style="color:#FF6801">5%</span> Discount for Govt, Edu & Corporate Clients           </b></a>
            </div>
            <div class="col-3">
                <a class="" style="color: black;" href="mailto:{{email}}"><b><i  class="fa fa-envelope" aria-hidden="true"></i></b>&nbsp; {{email}}</a>
            </div>
        </div>
    </div>
</div>
<!-- .topbar / end -->
